import React, { useState } from "react";
import { useToast } from "../../hooks/use-toast";
import Reveal from "../common/Reveal";
import { track, sha256 } from "../../lib/tracking";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    const em = await sha256(email);
    track("subscribe", { user_data: { em }, custom_data: { content_name: "newsletter" } });
    toast({ title: "Welcome to the LYBL community!", description: "Thanks for joining. We'll be in touch soon." });
    setEmail(""); setName("");
  };

  return (
    <section className="bg-lybl-cream py-20 lg:py-28">
      <div className="mx-auto max-w-4xl px-5 lg:px-8 text-center">
        <Reveal><p className="text-[13px] font-semibold uppercase tracking-[0.18em] text-lybl-rust">Newsletter</p></Reveal>
        <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-lybl-ink text-balance">Ready to find what works for your body?</h2></Reveal>
        <Reveal delay={140}>
          <form onSubmit={submit} className="mt-9 flex flex-col sm:flex-row gap-3 max-w-xl mx-auto">
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name (optional)" className="flex-1 rounded-full border border-lybl-ink/15 bg-white px-5 py-3.5 text-[15px] outline-none focus:border-lybl-green focus:ring-2 focus:ring-lybl-green/20 transition" />
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email address" className="flex-1 rounded-full border border-lybl-ink/15 bg-white px-5 py-3.5 text-[15px] outline-none focus:border-lybl-green focus:ring-2 focus:ring-lybl-green/20 transition" />
            <button type="submit" className="rounded-full bg-lybl-green px-6 py-3.5 text-[15px] font-medium text-white hover:bg-lybl-greenDark transition-colors whitespace-nowrap">Join →</button>
          </form>
        </Reveal>
        <p className="mt-4 text-[13px] text-lybl-muted">No spam, ever. Unsubscribe anytime.</p>
      </div>
    </section>
  );
}
